/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1TemplateReport } from '../models/V1TemplateReport';
import { HttpFile } from '../http/http';

export class V1RouteJobReport {
    'routeName'?: string;
    'orgId'?: string;
    'status'?: string;
    'templatesSent'?: number;
    'templateReports'?: Array<V1TemplateReport>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "routeName",
            "baseName": "routeName",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "orgId",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "templatesSent",
            "baseName": "templatesSent",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "templateReports",
            "baseName": "templateReports",
            "type": "Array<V1TemplateReport>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1RouteJobReport.attributeTypeMap;
    }

    public constructor() {
    }
}

